import Splide from '@splidejs/splide';
import "./components/item/ItemImageCarousel";
import "./components/item/Carousel";
import "./components/events/events";

import LazyLoad from "vanilla-lazyload";


/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;
/*
export default {
    mounted() {
     
    }
  }
*/

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
window.homeSliderElement = null;
function initHomeSlider(){
    if(homeSliderElement != null){
        console.log("destroyHomeSlider");
        homeSliderElement.destroy();
    }

    
    var initHomeSlider = false;
    var homeSliderInterval = setInterval(function () {
        if($('.splide-slider').length > 0 && !initHomeSlider){
            console.log("INIT HOMESLIDER")
            initHomeSlider = false;
            homeSliderElement = new Splide('.splide-slider',{
                mediaQuery: 'min',
                type   : 'loop',
                pagination: true,
                arrows: false,
                perPage: 1,
                perMove: 1,
           
                breakpoints:{
                    1200: {
                        arrows: true,
                        pagination: false,
                    },
                }
            }).mount();
            clearInterval(homeSliderInterval); 
        }
    }, 100);
}
function initSlider(){
   
    
    if($('.splide-slider-cats').length > 0){
        new Splide('.splide-slider-cats', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '30px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true
                },
                992: {
                    perPage: 4,
                    fixedWidth: false,
                    arrows: true
                },
            }
          }).mount();
    }
    
    if($('.splide-slider-stepbystep').length > 0){
        new Splide('.splide-slider-stepbystep', {
            fixedWidth: '252px',
            drag   : 'free',
            gap    : '15px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true,
                },
                992: {
                    destroy: true,
                    gap    : '30px',
                },
            }
          }).mount();
    }
    if($('.splide-slider-rezept-simple').length > 0){
        new Splide('.splide-slider-rezept-simple', {
            fixedWidth: '200px',
            drag   : 'free',
            gap    : '30px',
            mediaQuery: 'min',
            pagination: false,
            arrows: false,
            breakpoints:{
                768: {
                    perPage: 3,
                    fixedWidth: false,
                    arrows: true
                }
            }
          }).mount();
    }
}

$(document).ready(function(){
  console.log("drinn")
    const lazyContent = new LazyLoad({
        elements_selector: '.rf-lazy',
        use_native: false,
        threshold: 500 // <-- there you go
    });
    
    

    initSlider(); 
    initHomeSlider();
})
 	

$(document).on( "click", ".ts-rating-item", function(event) {
    
    if(!$('.nav-tabs .nav-item:last-child a').hasClass('active')){
        //tab-pane
        $('.nav-tabs .nav-item:last-child a')[0].click();
        var offsetTopTab = $('.tab-content').offset().top - 100;
        if($(document).width() < 768){
            offsetTopTab = $('.tab-content').offset().top + 200;
        }
        $("html, body").animate({ scrollTop: offsetTopTab }, 700);
    }
    

});
document.onreadystatechange = function () {
    if (document.readyState == "complete") {
        if($('.splide-rezept-slider-item').length > 0){
            new Splide('.splide-rezept-slider-item',{
                fixedWidth: '180px',
                drag   : 'free',
                gap    : '30px',
                perPage: 1,
                arrows: false,
                gap    : '15px',
                mediaQuery: 'min',
                pagination: false,
                breakpoints:{
                    768: {
                        fixedWidth: false,
                        pagination: true
                    }
                }
            }).mount();
        }
        /*if($('.category-list-item').length > 0){
            var summaryBadgeCat = new productStickerSummary();
            $('.category-list-item').each(function(){
                var itemId = $(this).data('itemid');
                var targetClass = ".ts-reviews-placeholder-"+$(this).data('itemid');
                summaryBadgeCat.showSummary({
                    'tsId': 'X24F440F634E19777117B620C5F660235',
                    'sku': "'"+itemId+"'",
                    'element': targetClass,
                    'starColor': '#FFDC0F',
                    'starSize': '14px',
                    'fontSize': '12px',
                    'showRating' : 'true',
                    'scrollToReviews' : 'false',
                    'enablePlaceholder': 'true'
                });
            })
           
        }*/
    }
  }
/*
$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    $('.owl-widget-home-carousel').owlCarousel({
            loop:true,
            nav:true,
            items: 1
        })
   console.log("DROP")
});*/

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
   if($(widgetElement).hasClass('splide-slider')){
        console.log("inhomeinit")
        initHomeSlider();
   }
   
});
$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        const ssIntervall = setInterval(function(){
            if($('.splide').length > 0){
                initSlider();
                const lazyContent = new LazyLoad({
                    elements_selector: '.rf-lazy',
                    use_native: false // <-- there you go
                });
                clearInterval(ssIntervall); 
            }
            
        }, 100);
        
        initShopbuilderScripts = true;
    }
    
    
});

// when the active dropzone in the shopbuilder changes
/*
$(document).on("shopbuilder.after.activate-container", (event, data) =>
{
    console.log(data?.container );
});*/
setInterval(function(){ 
    if($(document).width()<768){
        var elem = $('.top-header-usp .active-point');
        $(elem).removeClass('active-point')
        if($(elem).next('li').length>0){
            $(elem).next('li').addClass('active-point');
        }else{
            $('.top-header-usp li').first().addClass('active-point');
        }

    }
}, 3000);


if($('.isB2B').length > 0){

    const dfLayerOptions = {
      installationId: '5409fc5c-b058-4d81-8405-66649521333d',
      zone: 'eu1'
    };
    (function (l, a, y, e, r, s) {
      r = l.createElement(a); r.onload = e; r.async = 1; r.src = y;
      s = l.getElementsByTagName(a)[0]; s.parentNode.insertBefore(r, s);
    })(document, 'script', 'https://cdn.doofinder.com/livelayer/1/js/loader.min.js', function () {
      doofinderLoader.load(dfLayerOptions);
    });
  }else{
    const dfLayerOptions = {
      installationId: '3e1af9e9-56c4-4517-979c-457734a07c11',
      zone: 'eu1'
    };
    (function (l, a, y, e, r, s) {
      r = l.createElement(a);
      r.onload = e;
      r.async = 1;
      r.src = y;
      s = l.getElementsByTagName(a)[0];
      s.parentNode.insertBefore(r, s);
    })(document, 'script', 'https://cdn.doofinder.com/livelayer/1/js/loader.min.js', function () {
      doofinderLoader.load(dfLayerOptions);
    });  
  }

// define an observer instance
var observer = new IntersectionObserver(onIntersection, {
    root: null,   // default is the viewport
    threshold: .1 // percentage of target's visible area. Triggers "onIntersection"
  })
  
  // callback is called on intersection change
  function onIntersection(entries, opts){
        entries.forEach(entry =>  {
            if(window.innerWidth <= 768){
                const rootBottom = entry.rootBounds.height;
                const bottomBound = entry.boundingClientRect.bottom - rootBottom;
                let className = 'not-fixed';
                if(bottomBound <= 0){
                    className = 'is-fixed';
                }
                document.querySelector('.widget-add-to-basket').setAttribute('data-view', className);
                document.querySelector('.wrap-add-basket').setAttribute('data-view', className);
                document.querySelector('.footer-custom').setAttribute('data-view', className);
            }

            
        }
    )
  }

  $(document).ready(function(){
    if($('.wrap-add-basket').length > 0){
        observer.observe( document.querySelector('.wrap-add-basket') )
    }
    
  })
  
$(document).on('click','.item-gallery-right-btn',function(){
    MagicZoom.next('item-magiczoom');
})

$(document).on('click','.item-gallery-left-btn',function(){
    MagicZoom.prev('item-magiczoom');
})
/*
$.ajax({
    type: "GET",
    url: '/rest/vatcheck/',
    dataType: 'json',
    success: function(response){ console.log(response) }
  });*/
window.setCookie = setCookie;
window.getCookie = getCookie;
window.initSlider = initSlider;
window.initHomeSlider = initHomeSlider;